import { render } from "./Ruler.vue?vue&type=template&id=ca9f7576&scoped=true&bindings={\"dpi\":\"props\",\"fullScreen\":\"props\",\"screenText\":\"setup\",\"rulerLines\":\"setup\",\"rulerWidth\":\"setup\"}"
import script from "./Ruler.vue?vue&type=script&lang=js"
export * from "./Ruler.vue?vue&type=script&lang=js"

import "./Ruler.vue?vue&type=style&index=0&id=ca9f7576&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ca9f7576"

export default script